import { render, staticRenderFns } from "./online_aftersale_detail.vue?vue&type=template&id=5e350031&scoped=true"
import script from "./online_aftersale_detail.vue?vue&type=script&lang=js"
export * from "./online_aftersale_detail.vue?vue&type=script&lang=js"
import style0 from "./online_aftersale_detail.vue?vue&type=style&index=0&id=5e350031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e350031",
  null
  
)

export default component.exports